export const getInstitutionShortName = (state) =>
  state.institution && state.institution.general
    ? state.institution.general.institution
    : null;

export const getKeys = (state) =>
  state.institution && state.institution.keys ? state.institution.keys : {};
